import { Component, OnInit } from '@angular/core';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../../app-settings';
import { ActivatedRoute,Router } from '@angular/router';
import { SessionService } from '../../Services/session.service';

@Component({
  selector: 'app-archived-activity-details-body',
  templateUrl: './archived-activity-details-body.component.html',
  styleUrls: ['./archived-activity-details-body.component.css']
})
export class ArchivedActivityDetailsBodyComponent implements OnInit {
  userRole:string;
  getActivityTypeData:any;
  showContent:boolean = false;
  corelationID:string;
  sub:any;

  constructor(private httpClientService: HttpClientService, private sessionService: SessionService, private router:ActivatedRoute, private route:Router) { }

  ngOnInit()
  {
    this.sub = this.router.params.subscribe(params => {

      if(params['page'] && params['activity'])
      {
      this.showContent=true;
      window.scrollTo(0,0);
      }
      else if(params['corelationid'])
      {
          this.corelationID = params['corelationid'];
          this.redirect();
          this.showContent=false;

      }

    });


    this.getForumsData();
  }

   redirect()
   {
    this.httpClientService.get(AppSettings.restApiUrl+'/api/forum/configuration/'+this.corelationID + '/',new HttpHeaders()).subscribe((data)=>{
      console.log(data);
      let appName = data.appName;
      let redirectionURL = data.uri;
      if(appName=="MIQA"){
          window.location.href = redirectionURL;
      }else if(appName=="SCHOLARANIUM"){
          window.location.href = redirectionURL;
      }else if(appName.indexOf("PRACTICE")!=-1||appName.indexOf("TRIAL")!=-1){
          window.location.href = redirectionURL;
      }else{
        this.showContent=true;
      }

    });
  }

  getForumsData()
  {
    let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl +
          '/api/user/roles', headers)
      .subscribe(
      (data) => {
        var userExpert = data.filter(function(obj){

          return obj.name == "ROLE_EXPERT";
        });
        if(userExpert.length>0)
        {
          this.userRole = 'expert';
        }
        else
        {
          this.userRole = 'student';
        }
        this.sessionService.shareUserRole(this.userRole);
      }
      );
  }

}
